const { default: Swiper } = require('swiper');
const {
    swiperNavigation,
    handleSwiperProgressBar,
} = require('../modules/swiperModules');
const { Navigation, Mousewheel } = require('swiper/modules');

const sections = document.querySelectorAll('.categories-cards');
if (sections.length) {
    sections.forEach(section => {
        const swiperElement = section.querySelector('.swiper');
        const desktopCols = section.getAttribute('data-desktop-cols') ?? 3;
        if (swiperElement) {
            const paginationEl =
                swiperElement.querySelector('.slider-pagination');
            const arrowsEl = swiperElement.querySelector('.slider-arrows');

            let args = {
                modules: [Navigation, Mousewheel],
                direction: 'horizontal',
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                    invert: false,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.08,
                        slidesPerGroup: 1,
                        spaceBetween: 16,
                    },
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        spaceBetween: 16,
                    },
                    1023.98: {
                        slidesPerView: desktopCols,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                },
            };

            if (arrowsEl) {
                args = { ...args, ...swiperNavigation(arrowsEl) };
            }

            const swiper = new Swiper(swiperElement, args);

            if (paginationEl) {
                handleSwiperProgressBar(paginationEl, swiper);
            }
        }
    });
}
